import { IMG } from "./site";

const BOOK = "https://www.vagaro.com/luxveritaeskinspa";
const TEAM = "The Lux Veritae Team";

// Drafted SEO articles (set 2). Please review before relying on them as medical guidance.
export const DRAFTS_2 = [
  {
    slug: "scottsdale-med-spa-services-guide",
    category: "The Menu",
    title: "Every Treatment at Lux Veritae: A Scottsdale Med Spa Guide",
    dek: "Lasers, skin tightening, injectables, peels, body contouring and medical weight loss, all under one private roof.",
    author: TEAM, date: "The Edit", read: "6 min read", image: IMG.interior,
    body: `Lux Veritae Skin Spa is a private, boutique medical spa in Scottsdale. Our philosophy is simple: one trusted team, one personalized plan, and every service you need under one roof. Here is a guide to what we offer and who each treatment is for.

## Laser resurfacing

- **CO₂ laser resurfacing** (starting at $3,000): our most transformative laser for deep wrinkles, sun damage and acne scars. [Learn about CO₂](/treatments/co2-laser-resurfacing-scottsdale).
- **Erbium laser resurfacing** (starting at $2,500): precise renewal for fine lines, texture and tone, with shorter recovery. [Learn about Erbium](/treatments/erbium-laser-resurfacing-scottsdale).
- **Glass Skin Laser** (starting at $750): dual-wavelength MultiFrax for pigment and texture in one session.
- **Pigment correction, acne scar and tattoo removal lasers** for targeted concerns.

## Skin tightening

- **Xerf** (starting at $2,800): non-surgical radiofrequency tightening for the face, neck and body. [Learn about Xerf](/treatments/xerf-skin-tightening-scottsdale).
- **RF microneedling** (starting at $699): collagen building for firmness, pores, scars and stretch marks.
- **Plasma fibroblast**: targeted tightening for delicate areas.

## Injectables

Natural-looking refinement with **Botox® Cosmetic**, **Xeomin®**, **Juvéderm®** fillers, **SKINVIVE™** and **Kybella®**, always dosed to your features.

> The goal is never to look done. It is to look like yourself, rested and confident.

## Peels and facials

From the **Cosmelan® chemical peel** for melasma to VI Peels, hydration facials and the Hollywood Carbon Facial, our skincare menu treats every skin tone with medical-grade protocols.

## Body and wellness

- **CyroSlimming + EMS body contouring** (starting at $399) for stubborn areas.
- **Physician-supervised medical weight loss** programs starting at $299.

## Permanent makeup

Brow enhancement, lip blush, BB Glow and corrective work, designed around your face.

## Memberships

Our Glow, Signature, Lux Privé and Private VIP memberships make consistent care simple, with monthly treatments and member pricing. [See memberships](/memberships).

## Where to begin

Every plan starts with a complimentary consultation. [Book online](${BOOK}) or text us at (602) 886-3652.`,
  },
  {
    slug: "rf-microneedling-scottsdale",
    category: "Skin Tightening",
    title: "RF Microneedling in Scottsdale: Firmer Skin, Refined Texture",
    dek: "Why radiofrequency microneedling has become a cornerstone of non-surgical skin renewal.",
    author: TEAM, date: "The Edit", read: "4 min read", image: IMG.rfMicroneedling,
    body: `**RF microneedling** combines two proven ideas: tiny, controlled micro-channels in the skin, and radiofrequency energy delivered beneath the surface. Together they encourage the skin to produce fresh collagen and elastin, which is why it is one of the most requested treatments at our Scottsdale studio.

## What it can help with

- Loss of firmness on the face, neck and chest
- Enlarged pores and uneven texture
- Acne scarring
- Stretch marks

## What a session feels like

A numbing cream is applied before treatment for comfort. Most clients describe the sensation as warm and prickly. Skin is typically pink for a day or two, and most people return to normal routines quickly.

> Collagen is built, not bought. A series of sessions, spaced correctly, is where the transformation happens.

## How many sessions?

Most plans call for a series of three, spaced about four to six weeks apart, with results building over the following months. At Lux Veritae, packages of three receive 20% off.

## Pricing

RF microneedling at Lux Veritae starts at $699 for the face, with face and neck, chest, stretch mark and acne scar options. Cherry financing is available.

[Book an RF microneedling consultation](${BOOK}).`,
  },
  {
    slug: "glass-skin-laser-multifrax-scottsdale",
    category: "Lasers",
    title: "The Glass Skin Laser: Two Wavelengths, One Session",
    dek: "Inside the dual-wavelength MultiFrax treatment behind luminous, light-reflective skin.",
    author: TEAM, date: "The Edit", read: "4 min read", image: IMG.skincare,
    body: `“Glass skin” describes a complexion so even and smooth it seems to reflect light. Our **Glass Skin Laser** uses MultiFrax technology, which combines **1927 nm** and **1550 nm** wavelengths in a single non-ablative fractional treatment.

## Two wavelengths, two jobs

| Wavelength | Works on | Visible goal |
| --- | --- | --- |
| 1927 nm | The surface: pigment, sun damage, dull tone | Brighter, more even skin |
| 1550 nm | Deeper layers: collagen, fine lines, scarring | Smoother, firmer texture |

## Who it suits

Clients who want correction and radiance without the longer downtime of ablative resurfacing. Suitability for your skin tone and history is confirmed at consultation.

> Light, perfected. The goal is skin you are happy to show in any light.

## Recovery

Expect warmth and redness for a few days, followed by a fine, sandpaper-like texture as treated skin renews. Daily SPF is essential, especially under the Arizona sun.

## Pricing

The Glass Skin Laser starts at $750 for the full face. Our Skin Reset for face, neck and chest is $1,000 per session or $2,400 for a package of three.

[Book your Glass Skin consultation](${BOOK}).`,
  },
  {
    slug: "medical-weight-loss-glp1-scottsdale",
    category: "Wellness",
    title: "Medical Weight Loss in Scottsdale: A Physician-Supervised Approach",
    dek: "How GLP-1 programs with medical oversight fit into a complete body transformation plan.",
    author: TEAM, date: "The Edit", read: "4 min read", image: IMG.weight,
    body: `Lasting weight loss is rarely about willpower alone. **Physician-supervised medical weight loss** pairs medication, where appropriate, with structure, monitoring and accountability.

## How our programs work

Every program begins with a consultation and medical eligibility review. If GLP-1 medication is appropriate for you, dosing is introduced gradually and adjusted under medical supervision.

1. Consultation and eligibility review
2. A customized plan with medication if appropriate
3. Regular check-ins, in person or virtual
4. Progress tracking and guidance

## Beyond the scale

As weight changes, skin can lose firmness. Our Premium program includes monthly skin tightening so the result looks as refined as it feels.

> Lighter, firmer, and entirely you, with medical guidance at every step.

## Program pricing

| Program | Starting at |
| --- | --- |
| Starter Weight Loss Program | $299 |
| Standard Weight Loss Program | $399 |
| Premium Weight Loss + Sculpt Program | $499 |

Medication suitability is determined by a licensed medical provider. Not everyone is a candidate.

[Book a medical weight loss consultation](${BOOK}).`,
  },
  {
    slug: "permanent-makeup-brows-lip-blush-scottsdale",
    category: "Artistry",
    title: "Permanent Makeup, Quietly Done: Brows and Lip Blush",
    dek: "Semi-permanent artistry designed to look like you on your best day, never overdone.",
    author: TEAM, date: "The Edit", read: "3 min read", image: IMG.pmu,
    body: `The best permanent makeup is the kind nobody notices. It simply looks like naturally defined brows or naturally tinted lips. At Lux Veritae, **brow enhancement** and **lip blush** are designed around your features, not a trend.

## Brow enhancement

Brows are mapped to your bone structure and face shape, then defined with soft, natural-looking pigment. Clients with older brow work that has turned red, grey or blue can explore our corrective option.

## Lip blush

A semi-permanent tint for even tone, definition and subtly fuller-looking lips, with no filler.

> Wake up finished. Less time in the mirror, more confidence in every room.

## Healing and touch-ups

Colour looks bolder for the first days and softens as it heals. A follow-up visit refines shape and colour, and maintenance sessions keep everything fresh.

## Pricing

Eyebrow and lip blush enhancements are $650. Corrective brows are $525. Consultations are complimentary.

[Book a permanent makeup consultation](${BOOK}).`,
  },
];
